// General
export const COLUMN_INDEX = 0;

// Embeds
export const INSTAGRAM_ENDPOINT = 'https://graph.facebook.com/v10.0/instagram_oembed';
export const INSTAGRAM_URL = 'http://instagr.am/p';
export const INTERVAL = 100;
export const YOUTUBE_ENDPOINT = 'https://www.youtube.com/embed';
export const YOUTUBE_HEIGHT = 275;
export const TIKTOK_ENDPOINT = 'https://www.tiktok.com/oembed';

// Lib
export const TIKTOK_OEMBED_LIB = 'https://www.tiktok.com/embed.js';
